export const SUB_HEADER_PAGE_ELEMENT_ID = 'subHeaderPageElementId';
